import { PlaneTakeoff, PlaneLanding } from "lucide-react";

// EXPORT (CRL -> foreign) = blue · IMPORT (foreign -> CRL) = orange.
// Accepts export/import or departure/arrival.
export const DirectionBadge = ({ dir, className = "" }) => {
  const d = String(dir || "").toLowerCase();
  const isImport = d.startsWith("imp") || d.startsWith("arr");
  const label = isImport ? "IMPORT" : "EXPORT";
  const styles = isImport
    ? "bg-orange-100 text-orange-700 border-orange-200"
    : "bg-blue-100 text-blue-700 border-blue-200";
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wide ${styles} ${className}`}
      data-testid={`dir-badge-${label.toLowerCase()}`}
      title={label}
    >
      {isImport ? <PlaneLanding size={11} /> : <PlaneTakeoff size={11} />} {label}
    </span>
  );
};

export default DirectionBadge;
